import {useHttp} from '../http'

export const useInternshipApi = () => {

    const get = <T>(payload: any): Promise<T> => {
        return useHttp().get(`internships?relations=student,student.klasse,company,files`, payload)
    }

    return {
        get
    }
}
